'use client'

import { RefObject, useEffect } from 'react'

import { useSearchFilterStore } from '@/entities/map'
import { Filter, useFilterOptions } from '@/features/room-filter'
import { useAirbridgeContext } from '@/shared/config'
import { cn } from '@/shared/lib'

type Props = {
  ref?: RefObject<HTMLDivElement | null>
  isListScrolled?: boolean
  className?: string
}

export const MobileFilterMenuList = ({
  ref,
  isListScrolled = false,
  className,
}: Props) => {
  const airbridge = useAirbridgeContext()

  const hasChanged = useSearchFilterStore(state => state.hasChanged)

  const { FILTER_OPTIONS } = useFilterOptions()

  const handleClick = () => {
    airbridge.openDeeplink()
  }

  const handleTouch = (event: TouchEvent) => {
    event.stopPropagation()
  }

  useEffect(() => {
    const element = ref?.current
    if (!element) return

    element.addEventListener('touchstart', handleTouch, { passive: true })
    element.addEventListener('touchmove', handleTouch, { passive: true })
    element.addEventListener('touchend', handleTouch, { passive: true })

    return () => {
      element.removeEventListener('touchstart', handleTouch)
      element.removeEventListener('touchmove', handleTouch)
      element.removeEventListener('touchend', handleTouch)
    }
  }, [])

  return (
    <div
      className={cn(
        'relative flex gap-1.5 px-4 pb-3',
        isListScrolled && 'shadow-[0_0_10px_0_rgba(0,0,0,0.15)]',
        className,
      )}
      ref={ref}
      onClick={handleClick}
    >
      <Filter.All />
      <div
        className={cn(
          'flex gap-1.5',
          'touch-pan-x overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        )}
      >
        {FILTER_OPTIONS.map(({ title, type, field, width }) => (
          <Filter.Item key={type} width={width} selected={hasChanged(field)}>
            {title}
          </Filter.Item>
        ))}
      </div>
    </div>
  )
}
